import { ModelApiService } from './BaseApiService'

export default class LocationAlertApiService extends ModelApiService {
  constructor() {
    super('Location/LocationAlert')
  }

  async loadAllUpcomingAlerts() {
    return await this.get(``)
  }

  async loadLocationAlerts(ownerId) {
    if (ownerId) {
      return await this.get(`ByOwner/${ownerId}`)
    }
    return await this.get(`ByOwner`)
  }

  async removeLocationAlertsByIds(alertDeleteDto) {
    return await this.delete(``, alertDeleteDto)
  }

  async createByLocationIds(locationAlertRequestDto) {
    return await this.post(`CreateByLocationIds`, locationAlertRequestDto)
  }
}
